/**
 * CrmSweepWorker (crmsweep, 3 Oct 2026): renders nothing. When a member of the
 * Tohund Guide office has Karr open, it fills every client's missing date of
 * incorporation from the Tohund Guide CRM, once a day, and says what it did
 * and which clients the CRM could not answer for.
 *
 * Founder, 3 Oct 2026: *"why arent u able to fetch date of incorporation for
 * all clients in tohund guide via tohund guide api"*. The per-client lookup
 * (crmlive) only ran when somebody opened that client; this reaches the rest.
 *
 * Not started under the test runner, like MonthRunWorker.
 */
import { useEffect } from 'react';
import { useAuth } from '@/shared/hooks/useAuth';
import { toast } from '@/shared/ui/toast';
import { runCrmSweepDaily, sweepNotice, TOHUND_PRACTICE_ORG_ID } from './crmFill';

export function CrmSweepWorker(): null {
    const { orgs } = useAuth();
    const inOffice = import.meta.env.MODE !== 'test'
        && orgs.some((o) => (o as { id?: string }).id === TOHUND_PRACTICE_ORG_ID);

    useEffect(() => {
        if (!inOffice) return;
        void runCrmSweepDaily((filled, summary) => {
            const n = sweepNotice(filled, summary);
            if (n) toast.info(n.title, { description: n.description, duration: 15000 });
        });
    }, [inOffice]);
    return null;
}
